import { JointPropertyRegime, MaritalStatus, Race } from '@/types'
import { DefaultOccupations } from '@/types/ocupations'
import { SelectOption } from '@/types/select-option'

export const jointPropertyRegimeOptions: Array<
  SelectOption<JointPropertyRegime>
> = [
  {
    label: 'Comunhão parcial de bens',
    value: 'comunhao_parcial_de_bens',
  },
  {
    label: 'Comunhão universal de bens',
    value: 'comunhao_universal_de_bens',
  },
  {
    label: 'Separação total de bens',
    value: 'separacao_total_de_bens',
  },
  {
    label: 'Participação final nos aquestos',
    value: 'participacao_final_nos_aquestos',
  },
]

export const maritalStatusOptions: Array<SelectOption<MaritalStatus>> = [
  {
    label: 'Solteiro',
    value: 'single',
  },
  {
    label: 'Casado',
    value: 'married',
  },
  {
    label: 'União Estável',
    value: 'stable_union',
  },
  {
    label: 'Divorciado',
    value: 'divorced',
  },
  {
    label: 'Viúvo',
    value: 'widow',
  },
]

export const defaultOccupations: Array<SelectOption<DefaultOccupations>> = [
  {
    label: 'Médico(a)',
    value: 'Médico(a)',
  },
  {
    label: 'Enfermeiro(a)',
    value: 'Enfermeiro(a)',
  },
  {
    label: 'Psicólogo(a)',
    value: 'Psicólogo(a)',
  },
  {
    label: 'Fisioterapeuta',
    value: 'Fisioterapeuta',
  },
  {
    label: 'Nutricionista',
    value: 'Nutricionista',
  },
  {
    label: 'Outro',
    value: 'Outro',
  },
]

export const ethnicityOptions: Array<SelectOption<Race>> = [
  { label: 'Amarela', value: 'yellow' },
  { label: 'Branca', value: 'white' },
  { label: 'Indígena', value: 'indigenous' },
  { label: 'Parda', value: 'mixed' },
  { label: 'Preta', value: 'black' },
]

export const booleanOptions = [
  { label: 'Sim', value: true },
  { label: 'Não', value: false },
]

export const specializationsOptions = [
  'ACUPUNTURA',
  'ADMINISTRACAO EM SAUDE',
  'ADMINISTRACAO HOSPITALAR',
  'ALERGIA E IMUNOLOGIA',
  'ANATOMIA PATOLOGICA',
  'ANESTESIOLOGIA',
  'ANGIOLOGIA',
  'ANGIOLOGIA E CIRURGIA VASCULAR',
  'BRONCOESOFAGOLOGIA',
  'CANCEROLOGIA',
  'CANCEROLOGIA CIRURGICA',
  'CANCEROLOGIA CLINICA',
  'CANCEROLOGIA/CIRURGICA',
  'CANCEROLOGIA/CLINICA',
  'CANCEROLOGIA/PEDIATRICA',
  'CARDIOLOGIA',
  'CERT R MED CRED CNRM',
  'CERT RM NAO REG CNRM',
  'CERTIFICADO DE OUTRO CRM',
  'CIRURGIA CARDIOVASCULAR',
  'CIRURGIA DA MAO',
  'CIRURGIA DE CABECA E PESCOÇO',
  'CIRURGIA DO APARELHO DIGESTIVO',
  'CIRURGIA GERAL',
  'CIRURGIA ONCOLÓGICA',
  'CIRURGIA PEDIATRICA',
  'CIRURGIA PLASTICA',
  'CIRURGIA TORACICA',
  'CIRURGIA VASCULAR',
  'CITOLOGIA',
  'CITOPATOLOGIA',
  'CLINICA MEDICA',
  'COLO-PROCTOLOGIA',
  'CURSO ESPECIALIZACAO',
  'DECL EX MAG SUPERIOR',
  'DERMATOLOGIA',
  'DIAG IMAGEM:RADIOL INTERVENC E ANGIORRADIO',
  'DIAG POR IMAGEM:ULTRASSONOGRAFIA GERAL',
  'ELETROENCEFALOGRAFIA',
  'ENDOCRINOLOGIA',
  'ENDOCRINOLOGIA E METABOLOGIA',
  'ENDOSCOPIA',
  'ENDOSCOPIA DIGESTIVA',
  'ENDOSCOPIA PERORAL',
  'ENDOSCOPIA RESPIRATORIA',
  'ESP CIR NAO ESPECIF.',
  'ESP CIR.NAO CLASSIFI',
  'ESP CLIN NAO CLASSIF',
  'ESP CLIN NAO ESPECIF',
  'ESP DIAG NAO CLASSIF',
  'ESP DIAG NAO ESPECIF',
  'ESPECIAL NAO ESPECIF',
  'FISIATRIA',
  'GASTROENTEROLOGIA',
  'GENETICA CLINICA',
  'GENETICA MEDICA',
  'GERIATRIA',
  'GINECOLOGIA',
  'GINECOLOGIA E OBSTETRICIA',
  'HANSENOLOGIA',
  'HEMATOLOGIA',
  'HEMATOLOGIA E HEMOTERAPIA',
  'HEMOTERAPIA',
  'HEPATOLOGIA',
  'HOMEOPATIA',
  'INFECTOLOGIA',
  'MASTOLOGIA',
  'MED TRAB/PORT 11 MTPS/DSST',
  'MEDICINA DE EMERGÊNCIA',
  'MEDICINA DE FAMILIA E COMUNIDADE',
  'MEDICINA DO TRABALHO',
  'MEDICINA DO TRAFEGO',
  'MEDICINA ESPORTIVA',
  'MEDICINA FISICA E REABILITACAO',
  'MEDICINA GERAL COMUNITARIA',
  'MEDICINA INTENSIVA',
  'MEDICINA INTERNA',
  'MEDICINA LEGAL',
  'MEDICINA LEGAL E PERICIA MEDICA',
  'MEDICINA NUCLEAR',
  'MEDICINA PREVENTIVA E SOCIAL',
  'MEDICINA SANITARIA',
  'NEFROLOGIA',
  'NEUROCIRURGIA',
  'NEUROFISIOLOGIA CLINICA',
  'NEUROLOGIA',
  'NEUROLOGIA PEDIATRICA',
  'NUTRICAO PARENTERAL E ENTERAL',
  'NUTROLOGIA',
  'OBSTETRICIA',
  'OFTALMOLOGIA',
  'ONCOLOGIA CLÍNICA',
  'ORTOPEDIA E TRAUMATOLOGIA',
  'OTORRINOLARINGOLOGIA',
  'PATOLOGIA',
  'PATOLOGIA CLINICA',
  'PATOLOGIA CLINICA/MEDICINA LABORATORIAL',
  'PEDIATRIA',
  'PNEUMOLOGIA',
  'PROCTOLOGIA',
  'PSIQUIATRIA',
  'RADIOLOGIA',
  'RADIOLOGIA E DIAGNOSTICO POR IMAGEM',
  'RADIOTERAPIA',
  'REUMATOLOGIA',
  'SEXOLOGIA',
  'TERAPIA INTENSIVA',
  'TISIOLOGIA',
  'TITULO DE DOUTORADO',
  'TITULO DE MESTRADO',
  'TITULO ESPECIALISTA',
  'TITULO LIV DOCENCIA',
  'UROLOGIA',
  'VARIAS ESPS CLINICAS',
  'VARIAS ESPS DIAGNOST',
  'VARIAS ESPS.CIRURG.',
]
